export enum OS {
    windows = 'windows',
    mac = 'mac',
    linux = 'linux',
    unix = 'unix',
    android = 'android',
}

const charsToOSMap = {
    Win: OS.windows,
    Mac: OS.mac,
    X11: OS.unix,
    Android: OS.android,
    Linux: OS.linux,
};

export default function detectOSName(userAgent?: string): OS | null {
    userAgent ??= navigator?.userAgent;
    if (!userAgent) {
        return null;
    }

    for (const [chars, os] of Object.entries(charsToOSMap)) {
        if (userAgent.indexOf(chars) !== -1) {
            return os;
        }
    }

    return null;
}
